import {
  ActionResult,
  ApplicableContext,
  BaseAction,
  ExecuteContext,
} from '../../actions/framework';
import { ChatModel } from '../chat.model';
import { z } from 'zod/v3';
import { ExecuteToolAction } from './execute-tool.action';
import { ok } from 'neverthrow';

export class ExecuteAllIncompleteToolCallsAction extends BaseAction<
  {},
  { t: string; message?: string }[]
> {
  title = 'Execute All Incomplete Tool Calls';
  inputSchema = z.object({});
  group = 'Chat';
  shortcut = ['ctrl', 'shift', 'a'];
  icon = 'play';

  applicable(context: ApplicableContext): boolean {
    const chatModel = context.targetedModelOfType(ChatModel);
    return chatModel !== null && chatModel.hasIncompleteToolCalls();
  }

  async execute(
    _: {},
    context: ExecuteContext
  ): Promise<ActionResult<{ t: string; message?: string }[]>> {
    const model = context.targetedModelOfType(ChatModel)!;

    const toolCalls = model.messages
      .filter((x) => (x.toolInvocations?.incomplete().length ?? 0) > 0)
      .map((x) => x.toolInvocations!.incomplete())
      .flat();

    const executeToolAction = context.getAction(ExecuteToolAction);

    const results = await Promise.all(
      toolCalls.map((toolCall) =>
        executeToolAction.askOrExecute(
          { toolCallId: toolCall.toolCallId },
          context
        )
      )
    );

    const firstError = results.find((result) => result.isErr());
    if (firstError) {
      return firstError;
    }

    return ok({});
  }
}
